import { ChangeDetectorRef, Directive, ElementRef, Input, OnChanges, OnDestroy, OnInit, Renderer2, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { InternalLinksService } from './internal-links.service';

@Directive({
    selector: '[htmlBinding]',
    standalone: true
})
export class HTMLBindingDirective implements OnInit, OnChanges, OnDestroy {
    static directiveAdd = new Subject<HTMLBindingDirective>();
    static directiveRemove = new Subject<HTMLBindingDirective>();

    @Input()
    htmlBinding: string | undefined;

    @Input()
    unsafe?: boolean;

    private initiated = false;

    readonly htmlChange$ = new Subject<void>();

    constructor(
        ref: ChangeDetectorRef,
        private elementRef: ElementRef,
        private renderer2: Renderer2,
        private internalLinksService: InternalLinksService
    ) {
        ref.detach();
    }

    ngOnInit() {
        HTMLBindingDirective.directiveAdd.next(this);
        this.initiated = true;
        this.apply();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['htmlBinding']) {
            this.htmlChange$.next();
        }
        this.apply();
    }

    ngOnDestroy(): void {
        this.htmlChange$.unsubscribe();
        HTMLBindingDirective.directiveRemove.next(this);
    }

    getHtml(): string {
        return this.htmlBinding || '';
    }

    setHtml(html: string, soft = false) {
        if (this.htmlBinding !== html) {
            this.htmlBinding = html;
            if (!soft) {
                this.apply();
            }
        }
    }

    private apply() {
        if (this.initiated) {
            const el = this.elementRef.nativeElement;
            this.renderer2.setProperty(el, 'innerHTML', this.htmlBinding || '');
            this.internalLinksService.bind(el);
        }
    }
}
